import Cookies from 'js-cookie';

type User = {
  id: string;
  name: string;
  email: string;
  phoneNumber?: string | null;
};

export const isAuthenticated = () => !!Cookies.get('token');

export const storeLoginCredentials = (
  user: User,
  tokenId: string,
  adminLoggingInAsUser?: boolean
) => {
  Cookies.set('token', tokenId, { expires: 365 });
  Cookies.set('user', JSON.stringify(user), { expires: 365 });
  Cookies.set('adminLoggingInAsUser', adminLoggingInAsUser ? 'true' : 'false', { expires: 365 });
};

export const getToken = () => (Cookies.get('token') ? Cookies.get('token') : '');
export const getUser = () => (Cookies.get('user') ? JSON.parse(Cookies.get('user')) : '');

export const isAdminLoggingInAsUser = () => Cookies.get('adminLoggingInAsUser') === 'true';

export const logout = () => {
  Cookies.remove('token');
  Cookies.remove('user');
  Cookies.remove('adminLoggingInAsUser');
  refresh();
};

export const generatePassword = (length: number) => {
  const lowerCase = 'abcdefghijklmnopqrstuvwxyz';
  const upperCase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';
  const symbols = '!@#$%&*()';

  const allChars = lowerCase + upperCase + numbers + symbols;

  let password = '';
  password += lowerCase[Math.floor(Math.random() * lowerCase.length)];
  password += upperCase[Math.floor(Math.random() * upperCase.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];
  password += symbols[Math.floor(Math.random() * symbols.length)];

  for (let i = password.length; i < length; i++) {
    password += allChars[Math.floor(Math.random() * allChars.length)];
  }

  password = password
    .split('')
    .sort(() => 0.5 - Math.random())
    .join('');

  return password;
};

const refresh = () => window.location.reload();
